import { gql } from "apollo-boost";

const GET_VENDOR_LIST = gql`
  query getConsignmentVendorList($input: ShippingLabelInput!) {
    getConsignmentVendorList(input: $input) {
      status
      data {
        label
        value
      }
      error
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { GET_VENDOR_LIST };
